import { isNil, isNilOrEmpty } from "@salespark/toolkit";
import BunnyVideoV2 from "./VideoLessonBunnyV2";

const VideoLibraryLesson = ({ course, videos_info, details, updateVideoCurrentTimeHandler, progressHandler }) => {
  const actualVideo = videos_info.find((item) => item.video_id === details?.video_source);

  if (isNilOrEmpty(actualVideo?.video_id)) {
    console.log("Video ID is missing or invalid.");
    return <></>;
  }

  return (
    <BunnyVideoV2
      videoData={actualVideo}
      course={course}
      videos_info={videos_info}
      details={details}
      updateVideoCurrentTimeHandler={updateVideoCurrentTimeHandler}
      progressHandler={progressHandler}
    />
  );
};
export default VideoLibraryLesson;
